module.exports = __webpack_public_path__ + "uk.424f55f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/uk.jpg
// module id = 1865
// module chunks = 0